export const environment = {
  production: false,
  graphqlUrl: 'https://staging.belenus.api-gateway.innovax.cl/graphql',
  apiUrl: 'https://staging.belenus.api-gateway.innovax.cl/api',
  exportApiUrl: 'https://staging.belenus.api-gateway.innovax.cl/api',
};
